import { Modal, pointer, Text } from '@byecode/ui'
import React, { useCallback, useEffect } from 'react'
import styled from 'styled-components'

import { atomStore, errorIdAtom } from '../../atom'

interface ErrorFallbackProps {
    error: Error
    resetErrorBoundary: () => void
}

interface ErrorMessageProps {
    error: Error
    children?: React.ReactNode
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 12px 0;
`

const TextButton = styled(Text)`
    ${pointer}
    user-select: none;
`

const failedModuleId = 'failedModule'

export const ErrorMessage: React.FC<ErrorMessageProps> = ({ error, children }) => (
    <Container role="alert">
        <Text inline size={14} color="var(--color-gray-500)">
            发生未知错误: {error.message}
        </Text>
        {children}
    </Container>
)

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error, resetErrorBoundary }) => {
    console.error(error)
    const isFailedModule = error.message.includes('Failed to fetch dynamically imported module')

    const handleReloadPage = useCallback(() => {
        window.location.reload()
    }, [])

    const handleConfirm = useCallback(async () => {
        const isConfirm = await Modal.confirm({
            title: '检测到最新版本',
            content: '刷新网页以升级到最新的版本',
            okText: '刷新',
            okStatus: 'primary',
            withCancel: false
        })
        if (isConfirm) {
            handleReloadPage()
        }
    }, [handleReloadPage])

    useEffect(() => {
        const errorId = atomStore.get(errorIdAtom)
        if (errorId !== failedModuleId && isFailedModule) {
            atomStore.set(errorIdAtom, failedModuleId)
            handleConfirm()
        }
    }, [handleConfirm, isFailedModule])

    return (
        <ErrorMessage error={error}>
            <TextButton inline size={14} color="var(--color-main)" onClick={resetErrorBoundary}>
                刷新重试
            </TextButton>
        </ErrorMessage>
    )
}
